import { useMemo } from "react";

import { Button, Flex } from "@chakra-ui/react";

import { MultiSelectDropdown } from "@/components/2/multiselect-dropdown";

import { ThirdPartiesErrorsFiltersType } from "./types";

type ThirdPartiesErrorsFiltersProps = {
  setFilters: (filters: ThirdPartiesErrorsFiltersType) => void;
  filters: ThirdPartiesErrorsFiltersType;
};

const ProviderOptions = [
  { label: "Google", value: "google" },
  { label: "Microsoft", value: "microsoft" },
  { label: "Slack", value: "slack" },
];

const ErrorTypeOptions = [
  { label: "Parti mais toujours actif", value: "gone_but_active" },
  { label: "Parti depuis longtemps mais archivé", value: "long_gone_but_still_archived" },
  { label: "Pas de lien", value: "no_link" },
];

export const ThirdPartiesErrorsFilters = ({
  filters,
  setFilters,
}: ThirdPartiesErrorsFiltersProps) => {
  const resetFilters = useMemo(
    () => () => {
      setFilters({});
    },
    [setFilters]
  );

  // Check if any filter is applied to enable the reset button
  const enableResetButton = () =>
    Object.values(filters).some(filter => filter && Array.isArray(filter) && filter.length > 0);

  return (
    <Flex justifyContent={"flex-start"} alignItems={"center"} gap={2}>
      <MultiSelectDropdown
        name="providers"
        label="Fournisseur"
        pluralLabel="Fournisseurs"
        options={ProviderOptions}
        values={filters.providers || []}
        onChangeValues={newValues => setFilters({ ...filters, providers: newValues })}
      />

      <MultiSelectDropdown
        name="errorTypes"
        label="Type d'erreur"
        pluralLabel="Types d'erreur"
        options={ErrorTypeOptions}
        values={filters.errorTypes || []}
        onChangeValues={newValues => setFilters({ ...filters, errorTypes: newValues })}
      />

      {enableResetButton() && (
        <Button variant="plain" color={"blue"} onClick={resetFilters}>
          Effacer les filtres
        </Button>
      )}
    </Flex>
  );
};
